import { Controller } from '@hotwired/stimulus'
import Drift from 'drift-zoom'

export default class extends Controller {
  static targets = ['image', 'pane']

  connect() {
    if (!this.hasImageTarget || !this.hasPaneTarget) return

    this.drift = new Drift(this.imageTarget, {
      paneContainer: this.paneTarget,
      inlinePane: false,
      hoverBoundingBox: true,
      handleTouch: false,
      boundingBoxContainer: this.imageTarget.parentElement,
      onShow: () => this.paneTarget.classList.remove('hidden'),
      onHide: () => this.paneTarget.classList.add('hidden')
    })
  }

  disconnect() {
    this.drift?.destroy()
  }
}
